/**
 * @ngInject
 */

function twitterShare () {
    function link (scope, elem, attrs) {

        var leftPosition, topPosition;
        var socialWindowWidthTw = 550;
        var socialWindowHeightTw = 420;
        leftPosition = (window.screen.width / 2) - ((socialWindowWidthTw / 2) + 10);
        topPosition = 200;
        var windowFeaturesTw = "status=no,height=" + socialWindowHeightTw + ",width=" + socialWindowWidthTw + ",resizable=yes,left=" + leftPosition + ",top=" + topPosition + ",screenX=" + leftPosition + ",screenY=" + topPosition + ",toolbar=no,menubar=no,scrollbars=no,location=no,directories=no";

        elem[0].addEventListener('click', function(event){
            window.open("http://twitter.com/share?url=" + encodeURIComponent(attrs.twitterShare) + "", "tweet", windowFeaturesTw);
        });
    }

    return {
        restrict : 'A',
        link : link
    };
}